






















































// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getDefaultAloUser, AloUser } from '@/models/alo/AloUser'
import { AloFamCarte} from '@/models/alo/AloFamCarte'
import { directPayloadQuery } from '@/utils/api'
import apiFamily from '@/api/family'

@Component({
  name: 'ReadTickets',    
   props: {
    famId:{      
      type:Number,
      default:0
    }
  }
})
export default class ReadTickets extends Vue {
  private famId!:number
  private loading = false
  private all = false
  private commandes:Array<AloFamCarte> = []

  get tickets(){
    return this.commandes.filter(c => !c.isAbonnement)
  }

  get abonnements(){
    return this.commandes.filter(c => c.isAbonnement)
  }

  quantiteTickets(carte:AloFamCarte){
    if(carte.crwQty == 1) return this.$tc("Person.Tickets",carte.cftNbEntree)
    else return `${carte.crwQty} x ${this.$tc("Person.Tickets",carte.cftNbEntree)}`
  }

  quantiteAbonnement(carte:AloFamCarte){
    if(carte.crwQty == 1) return `${this.$tc("Person.Tickets",carte.cftNbEntree)} / semaine`
    else return `${carte.crwQty} x ${this.$tc("Person.Tickets",carte.cftNbEntree)} / semaine`
  }

  private headersTickets = [            
    { text: 'Num carte', value: 'id', width:120},           
    { text: 'Statut', value: 'status'},       
    { text: 'Forfait', value: 'libelle'},       
    { text: 'Quantité', value: 'crwQty'},       
    { text: 'Fin de validité', value: 'finValidite', width:160  },        
    { text: 'Utilisation', value: 'nbUsed', width:110 }
  ]

  private headersAbonnements = [                
    { text: 'Num abo', value: 'id', width:120},
    { text: 'Statut', value: 'status'},       
    { text: 'Forfait', value: 'libelle'},       
    { text: 'Quantité', value: 'crwQty'},       
    { text: 'Fin d\'engagement', value: 'cftDatengagement', width:160  },        
    { text: 'Utilisation / semaine', value: 'nbUsed', width:110 }
  ]

  created(){
    if(this.famId > 0) this.loadTickets()
  }

  loadTickets(){
    this.loading = true
    directPayloadQuery(apiFamily.forfaits,{famId:this.famId,all:this.all}).then((commandes)=>{
      this.commandes = commandes
    }).finally(()=>{
      this.loading = false
    })
  }



  @Watch("famId")
  onFamIdChanged(newFamId:number){
    if(newFamId > 0) this.loadTickets()
  }

  @Watch("all")
  onAllChanged(all:boolean){
    if(this.famId > 0) this.loadTickets()
  }

  get configuration(){
    return this.$store.myGetters.configuration
  }
}
